/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Manager_Question_SavedInputs */



/**
* | output |
* | --- |
* | "Saved: {name} is now your manager." |
*
* @param {Manager_Question_SavedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_saved = /** @type {((inputs: Manager_Question_SavedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_SavedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Opgeslagen: ${i?.name} is nu je leidinggevende.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Enregistré : ${i?.name} est désormais votre responsable.`)
	return /** @type {LocalizedString} */ (`Saved: ${i?.name} is now your manager.`)
});